import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { Knowbe4Connector } from '../../connector';

export const Knowbe4Service = IntegrationService.make({
  connector: Knowbe4Connector,
  name: Integration_Service_Names_Enum.Knowbe4,
});
